import config from "configs/app";

export default function isSequencerUiHidden() {
  const rollupFeature = config.features.rollup;

  if (!rollupFeature.isEnabled) {
    return false;
  }

  if (rollupFeature.type === "morphl2" || config.app.tokenList) {
    return true;
  }

  return (
    rollupFeature.type === "optimistic" &&
    config.chain.verificationType === "sequencing"
  );
}
